import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import BaseModal from '@/modal/baseModal';
import Button from '@/ui-kit/Button';

interface Props {
  onClose: () => void;
  title: string;
  subTitle: string;
}

export const CbsNotif: React.FC<Props> = ({ title, subTitle, onClose }) => {
  const { t } = useTranslation();

  return (
    <BaseModal onClose={() => onClose()} width={'440px'}>
      <div className='mb-2 items-center w-full pt-6 pl-6'>
        <h6 className='mr-auto'>{t(title)}</h6>
      </div>
      <p className='body2s mb-6 w-full pl-6'>{t(subTitle)}</p>
      <div className={styles.modal__buttonSection}>
        <Button label={t('general.ok')} onClick={() => onClose()} inputStyle='w-[6.25rem] ml-auto' id='OkButton' />
      </div>
    </BaseModal>
  );
};
